import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import { watch, reactive, ref, toRefs } from 'vue';
import dayjs from 'dayjs';
import apis from '@/api';
export default {
  props: {
    assetId: String
  },
  emits: ['ok'],
  setup(props, ctx) {
    const form = ref('form');
    const data = reactive({
      dialogVisible: false,
      defaultTime: [new Date(2000, 1, 1, 0, 0, 0), new Date(2000, 2, 1, 23, 59, 59)],
      formData: {
        assetId: '',
        dateRange: ''
      },
      rules: {
        offerId: [{
          required: true,
          message: '请输入业务编码',
          trigger: 'blur'
        }],
        offerName: {
          required: true,
          message: '请输入业务名称',
          trigger: 'blur'
        },
        dateRange: {
          required: true,
          message: '请输入有效期',
          trigger: 'blur'
        }
      }
    });
    watch(() => props.assetId, assetId => {
      data.formData.assetId = assetId;
    }, {
      immediate: true
    });
    const confirmHandler = () => {
      form.value.validate(valid => {
        if (valid) {
          console.log(data.formData);
          apis.addAssetsBiz(data.formData).then(res => {
            if (res.success) {
              ElMessage.success("添加成功");
              close();
              ctx.emit('ok');
            } else {
              ElMessage.error(res.msg);
            }
          });
        } else {
          return false;
        }
      });
    };
    const close = () => {
      data.dialogVisible = false;
      data.formData = {}; // 清空对象，但保留素材id，避免连续添加同一个素材的业务时素材id为空
      data.formData = {
        assetId: props.assetId
      };
    };
    const visible = () => {
      // console.log("dada")
      data.dialogVisible = true;
    };
    const dateRangeChange = e => {
      data.formData.startTime = dayjs(e[0]).format("YYYY-MM-DD HH:mm:ss");
      data.formData.endTime = dayjs(e[1]).format("YYYY-MM-DD HH:mm:ss");
    };
    return {
      ...toRefs(data),
      confirmHandler,
      visible,
      dateRangeChange,
      form,
      close
    };
  }
};